import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  DropdownButton,
  MenuItem,
  FormGroup,
  InputGroup,
  FormControl,
  ButtonGroup,
  Modal,
  ControlLabel,
  Row,
  Col,
  Checkbox
} from "react-bootstrap";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";
import "../../../style/react-paginating.css";
import {
  formSetting,
  saveBecomeForm,
} from "../../../redux/actions/siteActions";
import moment from "moment";
import Dialog from "react-bootstrap-dialog";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import { allUser } from "../../../redux/actions/subAdminActions";

const history = createBrowserHistory();

let isLoading = "false";
class FormSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertMessage: "",
      msgType: "success",
      path: ["Home", "Form Setting"],
      links: ["home", "form-setting"],
      show: false,
      formList: [],
    };
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  componentWillMount() {
    this.props.formSetting('input-fields/list');
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.formList !== nextProps.formList){
    	if(nextProps.formList){
    		this.setState({formList: nextProps.formList})
    	}
    }

    if (this.props.formStatus !== nextProps.formStatus) {
      if (nextProps.formStatus) {
        this.props.clearAlert();
        this.handleShow();
        if (nextProps.formStatus.message) {
          isLoading = "false";
          window.scrollTo(0, 0);
          this.props.renderAlert("success", nextProps.formStatus.message);
        }
      }
    }

    if (nextProps.message) {
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        isLoading = "false";
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
      }
    }
  }

  handleEnabled = (e) => {
  	let newValue;
  	let indexValue = e.target.attributes.getNamedItem("data-key").value;

  	if(e.target.checked){
  		newValue = "0";
  	}else{
  		newValue = "1";
  	}

  	const newFormList = this.state.formList.map((data, idx) => {
      if (indexValue !== data.name) return data;
      return { ...data, enabled: newValue };
    });

    this.setState({formList: newFormList});
  }

  handleRequired = (e) => {
  	let newValue;
  	let indexValue = e.target.attributes.getNamedItem("data-key").value;

  	if(e.target.checked){
  		newValue = "0";
  	}else{
  		newValue = "1";
  	}

  	const newFormList = this.state.formList.map((data, idx) => {
      if (indexValue !== data.name) return data;
      return { ...data, required: newValue };
    });

    this.setState({formList: newFormList});
  }

  handleSubmit = (e) => {
    isLoading = "true";
  	const constData = {
  		data: this.state.formList,
  	}
  	this.props.saveBecomeForm(constData, 'input-fields/save');
  }

  render() {
    return (
      <div>
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />
        <div className="col-lg-12 user-list">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">Form Setting (Become A Partner)</header>
            <div className="panel-body">
              {this.state.show &&
                this.state.alertMessage !== "" && (
                  <div className="col-lg-12">
                    <Alert
                      bsStyle={this.state.msgType}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>{this.state.msgType}:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}
              <div className="clearfix" />
              <div className="row">
                <div className="col-lg-12">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>
                          Field
                        </th>
                        <th>Enable</th>
                        <th>Required</th>
                      </tr>
                    </thead>
                    <tbody>
                    	{this.state.formList &&
                    		this.state.formList.map((list, index) => 
		                    	<tr key={index}>
		                    		<td>{list.title}</td>
		                    		<td><Checkbox data-key={list.name} onClick={this.handleEnabled} defaultChecked={list.enabled == '0' ? true : false}></Checkbox></td>
		                    		<td><Checkbox data-key={list.name} onClick={this.handleRequired} defaultChecked={list.required == '0' ? true : false}></Checkbox></td>
		                    	</tr>
                    		)
                    	}
                    </tbody>
                  </table>
                </div>
                <div className="col-lg-12">
                	<Button bsStyle="primary" onClick={this.handleSubmit}>Save</Button>
                </div>
              </div>
              <div className="clearfix" />
            </div>
          </div>
        </div> 
      </div>
    );
  }
}

const mapStateToProps = state => ({
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
  formList: state.siteReducer.formList,
  formStatus: state.siteReducer.formStatus,
  error: state.siteReducer.error,
});

export default connect(mapStateToProps, {
  renderAlert,
  clearAlert,
  formSetting,
  saveBecomeForm
})(FormSetting);



// WEBPACK FOOTER //
// ./src/app/views/admin/setting/FormSetting.js